<!-- banner image start -->
<div id="main-wrapper">
  <div class="site-wrapper-reveal">
    <div class="position-relative w-100">
      <div class="d-flex align-items-center h-100 w-100">
        <img src="../../../assets/images/team/teamBanner.png" class="img img-responsive w-100 h-100 d-none d-md-block"
          width="100%" alt="team banner" />
        <img src="../../../assets/images/team/teams-mobileimage.png" class="img img-responsive d-block d-md-none"
          width="100%" alt="mobile team banner" />
        <div class="position-absolute w-100 home-banner">
          <div class="row h-100 w-100">
            <div class="col-8 col-md-4 col-sm-6 banner-section">
              <div class="align-items-center global_title global_banner_title">
                <span>Our Team</span>
              </div>
              <div class="global_sub_title global_banner_subtitle mt-3">
                <span>We’re a fun, creative and ambitious team passionate to create impeccable digital experiences for
                  local to global brands</span>
              </div>
              <div class="col pt-lg-3 pt-3 mt-lg-3">
                <a routerlink="careers" href="careers" class="global_button text-left col text-white white_button" aria-label="View Careers Page">
                  <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="careers global button" /></div>
                  JOIN US
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- banner image end -->
<!-- our team contact start -->
<section>
  <div class="h-auto w-100 text-center py-5">
    <div class="team_our_header global_section_header h-auto w-100 text-center">
      Our people make all the difference
    </div>
    <div class="row">
      <div class="col-md-1 offset-md-1 col-sm-12"></div>
      <div class="col-md-8 col-sm-12">
        <div class="team_our_subheader global_section_content pt-4">The strength of the team is each individual member.
          The strength of each member is the team. We're imbued with a commitment to help businesses innovate, realize
          the value of technology, and drive impact.
        </div>
        <div class="col-md-2 offset-md-2 col-sm-12"></div>
      </div>
    </div>
  </div>
</section>
<!-- our team contact end -->
<!-- our team images start -->
<section id="team1" class="container mt-5">
  <div class="row">
    <div *ngFor="let member of teamMembers" class="col-md-6 col-lg-3 mb-5">
      <div class="card1">
        <img [src]="member.image" alt="{{member.name}}" class="w-100 card-img-top grayscale"  >
        <div class="card-body1">
          <p class="card-title1">{{member.name}}</p>
          <p class="Designation">{{member.designation}}</p>
          <a href="{{member.linkedin}}" target='blank' class="btn btn-primary card-text1 hidden1">
            <i class="fa-brands fa-linkedin-in" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>